import { render, staticRenderFns } from "./Capital.vue?vue&type=template&id=5f57f952"
import script from "./Capital.vue?vue&type=script&lang=js"
export * from "./Capital.vue?vue&type=script&lang=js"
import style0 from "./Capital.vue?vue&type=style&index=0&id=5f57f952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports